/**
 * Support hotline phone number shown across the portal (footer, account-disabled page, …).
 *
 * A phone number is locale-invariant, so it is not an i18n message — it lives here as the single
 * source of truth. Consumers that render it inside translated copy interpolate it into their i18n
 * message (e.g. `{{hotline}}`) rather than duplicating the literal.
 */
export const SUPPORT_HOTLINE_NUMBER = '0800 33 52 26 0';
